import { node } from 'prop-types';
import React from 'react';

function Layout({ children }) {
  return <div className="p-4">{children}</div>;
}

Layout.propTypes = {
  children: node.isRequired,
};

export default Layout;
